import { STATION_SIZE } from 'constants/map';
import { IconWrapper, selectedPathConnectingIconStyleMap } from '../../Station.styled';
import styled from 'styled-components';
import { Direction } from 'types';
import { ClearIcon, CodeIcon } from '@medly-components/icons';
import { DescriptionText, DescriptionWrapper } from '../Description/Description.styled';

export const ExpandIcon = styled(CodeIcon)`
    border: 0.1rem solid ${({ theme }) => theme.colors.grey[200]};
`;

export const CollapseIcon = styled(ClearIcon)``;

export const BigJunctureStationWrapper = styled.div<{
    selectedPathIntersectionDirection?: Direction | null;
    isPathSelectedInTour?: boolean;
}>`
    transform: translate(calc(-50% + ${STATION_SIZE / 2}px + 1rem), 0);
    border-radius: 3.2rem;
    position: absolute;
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.royalBlue[200]};
    z-index: 1;
    padding-right: 2rem;
    ${({ selectedPathIntersectionDirection }) =>
        selectedPathIntersectionDirection ? selectedPathConnectingIconStyleMap[selectedPathIntersectionDirection] : ''};

    ${IconWrapper} {
        background-color: transparent;
    }
    ${ExpandIcon}, ${CollapseIcon} {
        position: absolute;
        left: calc(100% - 2rem);
    }

    ${DescriptionWrapper} {
        left: 100%;
    }

    ${DescriptionText} {
        padding-left: 2rem;
        margin-left: 0;
    }
`;
